import { getIdFromSubjectUri } from '~/features-shared/libs/utils/subject-uri-utils'
import type { SwymSection, ThreadInSection } from '~/features-shared/sections/interface/swym-section'

import type { Section, SectionThread } from '~/features-generic/left-panel/interfaces/left-panel'
/**
 * Transforms a SwymSection into a Section
 * @param data API response from Swym API
 * @returns section data
 */
export function parseSection(data: SwymSection): Section<SectionThread> {
  return {
    id: data.uri,
    category: data.category,
    name: data.name,
    position: data.read_only ? data.read_only_position : data.position,
    isFavorite: data.read_only && data.read_only_position === 0,
    isReadOnly: data.read_only || false,
    threads: data.items?.map((item) => {
      return {
        threadId: getIdFromSubjectUri(item.subject_uri),
        position: item.position,
      }
    }) || [],
  }
}

/**
 * Transform add thread in section API response to section data
 * @param data API response from Swym API
 * @returns return section format data
 */
export function mergeThreadInSection(data: ThreadInSection): Section<SectionThread> {
  return {
    id: data.section.uri,
    name: data.section.name,
    threads: {
      threadId: data.subject_uri,
      position: data.position,
    },
  }
}
